// ClassTable.jsx
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Table from "../shared/table/Table";
import { FiEye, FiEdit3, FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

const ClassTable = () => {
  const [rows, setRows] = useState([]);
  const lang             = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;


  const fetchData = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/class/list`);
    setRows(res.data);
  };

  useEffect(() => { fetchData(); }, []);

const handleDelete = (id) => {
  confirmAlert({
    title: "Silmeyi Onayla",
    message: "Bu sınıfı silmek istediğinize emin misiniz?",
    buttons: [
      {
        label: "Evet, Sil",
        onClick: async () => {
          try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/class/${id}`);
            toast.success("Kayıt silindi.");
            fetchData(); // tabloyu güncelle
          } catch (err) {
            console.error("❌ Silme hatası:", err);
            toast.error("Silme işlemi başarısız oldu.");
          }
        }
      },
      {
        label: "İptal",
        onClick: () => {} // Hiçbir şey yapma
      }
    ]
  });
};

  const columns = useMemo(() => [
    { accessorKey: "id", header: () => "ID", size: 70 },
    {
      accessorKey: "cover",
      header: () => "Görsel",
      cell: (info) => {
        const value = info.getValue();
        if (!value) return null;
        const src = `${process.env.REACT_APP_API_BASE_URL}${value}`;
        return <img src={src} alt="cover" style={{ width: 80, height: 50, objectFit: "cover", borderRadius: 4 }} />;
      },
    },
    { accessorKey: "title", header: () => "Başlık" },
        {
      accessorKey: "created_at",
      header: () => t("TABLE_DATE", "Tarih"),
      cell: (info) => new Date(info.getValue()).toLocaleDateString("tr-TR"),
    },
    {
      accessorKey: "actions",
      header: () => "İşlemler",
      cell: (info) => {
        const id = info.row.original.id;
        return (
          <div className="d-flex gap-2">
            <Link to={`/classes/view/${id}`}
            className="avatar-text avatar-md text-primary bg-soft-primary border-soft-primary"
                           title={t("VIEW", "Görüntüle")}>
                            <FiEye />
            </Link>
            <Link to={`/classes/edit/${id}`} className="avatar-text avatar-md text-success bg-soft-success border-soft-success"
                          title={t("EDIT", "Düzenle")}>
                            <FiEdit3 /></Link>
            <button className="avatar-text avatar-md text-danger bg-soft-danger border-soft-danger"
                title={t("DELETE", "Sil")} onClick={() => handleDelete(id)}><FiTrash2 /></button>
          </div>
        );
      }
    }
  ], []);

  return <Table data={rows} columns={columns} />;
};

export default ClassTable;